import { ReactNode } from 'react'

type ActorHeaderProps = {
  title: ReactNode
  action?: ReactNode
}

const ActorHeader = ({ title, action }: ActorHeaderProps) => {
  return (
    <div className='h-6 px-1 flex items-center justify-between gap-2'>
      <div className='min-w-0 text-xs text-foreground leading-[14px]'>
        {title}
      </div>
      <div className='shrink-0 flex items-center'>{action}</div>
    </div>
  )
}

export default ActorHeader
